import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { ShoppingBag, Gift, Shield, Star, ArrowLeft } from 'lucide-react';

function Register() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white flex flex-col">
      {/* Main Content */}
      <div className="container mx-auto px-4 sm:px-6 py-8 flex-grow flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
        {/* Left Section */}
        <div className="w-full md:w-1/2 max-w-md">
          <div className="text-center md:text-left mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Create Your Account
            </h1>
            <p className="text-gray-600 text-base sm:text-lg mb-6">
              Join Ecomify today and discover a world of amazing products and exclusive benefits.
            </p>

            {/* Benefits Section */}
            <div className="space-y-4 text-left">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Star className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Exclusive Offers</h3>
                  <p className="text-sm text-gray-500">First-time customer discounts</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Gift className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Reward Points</h3>
                  <p className="text-sm text-gray-500">Earn on every purchase</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Shield className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Secure Account</h3>
                  <p className="text-sm text-gray-500">Protected by latest security</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section - Registration Form */}
        <div className="w-full md:w-1/2 max-w-md">
          <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 relative">
            {/* Custom Header */}
            <div className="text-center mb-6">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Sign up for free</h2>
              <p className="text-gray-600 mt-2 text-sm sm:text-base">Get started with your account today</p>
            </div>

            {/* Clerk SignUp Component with Custom Styling */}
            <SignUp
              signInUrl="/login"
              forceRedirectUrl="/"
              appearance={{
                variables: {
                  colorPrimary: '#10b981', // Emerald-500
                  colorBackground: '#FFFFFF',
                  borderRadius: '0.75rem',
                  fontFamily: 'Inter, system-ui, sans-serif',
                },
                elements: {
                  formButtonPrimary: 
                    'bg-emerald-500 hover:bg-emerald-600 transition-all duration-200 shadow-md hover:shadow-lg rounded-lg py-3 w-full',
                  card: 'shadow-none',
                  headerTitle: 'hidden',
                  headerSubtitle: 'hidden',
                  socialButtonsBlockButton: 
                    'border-2 hover:border-emerald-500 transition-all duration-200 rounded-lg py-3 w-full',
                  socialButtonsBlockButtonText: 
                    'font-medium',
                  formFieldLabel: 
                    'font-medium text-gray-700',
                  formFieldInput: 
                    'rounded-lg border-gray-300 focus:ring-emerald-500 focus:border-emerald-500 py-3 w-full',
                  footer: 'hidden',
                  dividerLine: 'bg-gray-200',
                  dividerText: 'text-gray-500',
                  formFieldInputShowPasswordButton: 'right-3',
                  formFieldAction: 'text-emerald-600 hover:text-emerald-700',
                  identityPreview: 'bg-emerald-50 border-emerald-100',
                  identityPreviewText: 'text-emerald-700',
                  identityPreviewEditButton: 'text-emerald-600 hover:text-emerald-700',
                },
              }}
            />

            {/* Additional Links */}
            <div className="mt-6 text-center">
              <p className="text-gray-600 text-xs sm:text-sm">
                Already have an account?{' '}
                <a 
                  href="/login" 
                  className="text-emerald-600 hover:text-emerald-700 font-medium inline-flex items-center"
                >
                  <ArrowLeft className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                  Sign in here
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t mt-auto">
        <div className="container mx-auto px-4 py-4 sm:py-6">
          <p className="text-center text-gray-600 text-xs sm:text-sm">
            © {new Date().getFullYear()} Ecomify. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Register;
